(function () {
  "use strict";

  angular.module("tikonApp").controller("CompanyBlogs", CompanyBlogs);

  CompanyBlogs.$inject = ["$timeout", "$state", "$rootScope"];

  function CompanyBlogs($timeout, $state, $rootScope) {
    function initBlogs() {
      var blogsElement = document.getElementById("company-blogs");
      blogsElement.addEventListener("prevPageBtn", function (e) {
        if ($rootScope.fromState.name)
          $state.go($rootScope.fromState.name, $rootScope.fromStateParams);
        else $state.go("supplierPanel-v2.setting");
        // closeModal()
      });
      blogsElement.addEventListener("toBlogCategories", function (e) {
        $state.go("supplierPanel-v2.companyBlogCategories");
        // closeModal()
      });
    }
    $timeout(initBlogs, 50);
  }
})();
